(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-story-toggle')) {
    class VideoStoryToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-video-more-btn]');
        this.panel = this.querySelector('[data-video-more]');
        this.label = this.querySelector('[data-video-more-btn-label]');
        this.button?.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const isOpen = this.panel?.hasAttribute('open');
        this.panel?.toggleAttribute('open', !isOpen);
        this.button?.setAttribute('aria-expanded', String(!isOpen));
        if (this.label && this.button) {
          this.label.textContent = isOpen
            ? this.button.dataset.moreLabel
            : this.button.dataset.lessLabel;
        }
      }
    }
    customElements.define('video-story-toggle', VideoStoryToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.dismissKey;
        if (sessionStorage.getItem(this.key) === '1') {
          this.hidden = true;
          return;
        }
        const dismissButton = this.querySelector('.announcement-bar__dismiss');
        dismissButton?.addEventListener('click', () => {
          this.hidden = true;
          sessionStorage.setItem(this.key, '1');
        });
      }
    }
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product-storyboard')) {
    class FeaturedProductStoryboard extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('[data-fp-item]');
        this.items.forEach((item) => {
          item.addEventListener('mouseenter', () => this.setActive(item.dataset.blockId));
          item.addEventListener('focus', () => this.setActive(item.dataset.blockId));
        });
      }

      setActive(blockId) {
        this.querySelectorAll('[data-fp-slide], [data-fp-panel], [data-fp-item]').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.blockId === blockId);
        });
      }
    }
    customElements.define('featured-product-storyboard', FeaturedProductStoryboard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('nav-dropdown')) {
    class NavDropdown extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.header__mobile-nav-toggle');
        this.toggle?.addEventListener('click', () => this.toggleOpen());
      }

      toggleOpen() {
        const isOpen = this.classList.toggle('is-open');
        this.toggle?.setAttribute('aria-expanded', String(isOpen));
      }
    }
    customElements.define('nav-dropdown', NavDropdown);
  }

  if (!customElements.get('header-component')) {
    class HeaderComponent extends HTMLElement {
      connectedCallback() {
        this.menuToggle = this.querySelector('.header__menu-toggle');
        this.menuClose = this.querySelector('.header__menu-close');
        this.scrim = this.querySelector('.header__mobile-nav-scrim');
        this.nav = this.querySelector('.header__mobile-nav');

        this.menuToggle?.addEventListener('click', () => this.openNav());
        this.menuClose?.addEventListener('click', () => this.closeNav());
        this.scrim?.addEventListener('click', () => this.closeNav());

        this.onNavLinkClick = () => this.closeNav();
        this.nav?.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', this.onNavLinkClick);
        });

        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-nav-open')) {
            this.closeNav();
          }
        };
        document.addEventListener('keydown', this.onKeydown);

        this.onScroll = () => {
          this.classList.toggle('header--scrolled', window.scrollY > 12);
        };
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });

        this.onCartUpdated = (event) => {
          const badge = this.querySelector('[data-cart-count]');
          if (!badge) return;
          const count = event.detail.cart.item_count;
          badge.textContent = count;
          badge.hidden = count === 0;
        };
        document.addEventListener('cart:updated', this.onCartUpdated);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('cart:updated', this.onCartUpdated);
        document.removeEventListener('keydown', this.onKeydown);
        this.closeNav();
      }

      openNav() {
        this.classList.add('is-nav-open');
        this.menuToggle?.setAttribute('aria-expanded', 'true');
        this.nav?.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mobile-nav-open');
        document.body.style.overflow = 'hidden';
      }

      closeNav() {
        this.classList.remove('is-nav-open');
        this.menuToggle?.setAttribute('aria-expanded', 'false');
        this.nav?.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mobile-nav-open');
        document.body.style.overflow = '';
      }
    }
    customElements.define('header-component', HeaderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-items')) {
    class CartItems extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('change', (event) => this.onChange(event));
      }

      onClick(event) {
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.updateLine(remove.dataset.lineIndex, 0);
          return;
        }

        const decrease = event.target.closest('[data-line-decrease]');
        const increase = event.target.closest('[data-line-increase]');
        if (!decrease && !increase) return;

        const wrapper = (decrease || increase).closest('.cart-page__quantity');
        const input = wrapper.querySelector('[data-quantity-input]');
        let value = parseInt(input.value, 10) || 0;
        value = decrease ? Math.max(0, value - 1) : value + 1;
        input.value = value;
        this.updateLine(input.dataset.lineIndex, value);
      }

      onChange(event) {
        const input = event.target.closest('[data-quantity-input]');
        if (!input) return;
        const value = Math.max(0, parseInt(input.value, 10) || 0);
        this.updateLine(input.dataset.lineIndex, value);
      }

      async updateLine(line, quantity) {
        this.classList.add('is-loading');
        try {
          const changeResponse = await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
          });
          const cart = await changeResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

          const sectionResponse = await fetch(this.dataset.sectionRenderUrl);
          const html = await sectionResponse.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const updated = parsed.getElementById(this.id);
          if (updated) {
            this.innerHTML = updated.innerHTML;
          } else {
            window.location.reload();
          }
        } catch (error) {
          window.location.reload();
        } finally {
          this.classList.remove('is-loading');
        }
      }
    }
    customElements.define('cart-items', CartItems);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-coupon-apply]');
    if (!button) return;
    var form = button.closest('[data-coupon-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input[name="discount_code"]');
    var code = ((input && input.value) || '').trim();
    if (!code) {
      if (input) input.focus();
      return;
    }
    window.location.href =
      form.dataset.applyUrlBase +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(form.dataset.redirectUrl);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-coupon-form] input[name="discount_code"]');
    if (!input) return;
    event.preventDefault();
    var form = input.closest('[data-coupon-form]');
    var button = form && form.querySelector('[data-coupon-apply]');
    if (button) button.click();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.product-gallery__stage');
        this.images = this.querySelectorAll('[data-gallery-image]');
        this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
        this.zoomed = false;

        this.stage?.addEventListener('click', () => this.toggleZoom());
        this.stage?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleZoom();
          }
        });
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.setActive(thumb.dataset.index));
        });
      }

      setActive(index) {
        this.zoomed = false;
        this.stage.classList.remove('is-zoomed');
        this.images.forEach((img) => img.classList.toggle('is-active', img.dataset.index === index));
        this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.index === index));
      }

      toggleZoom() {
        this.zoomed = !this.zoomed;
        this.stage.classList.toggle('is-zoomed', this.zoomed);
      }
    }
    customElements.define('product-gallery', ProductGallery);
  }

  if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.triggers = this.querySelectorAll('[data-tab-trigger]');
        this.panels = this.querySelectorAll('[data-tab-panel]');
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTrigger));
        });
      }

      activate(key) {
        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.tabTrigger === key;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', String(isActive));
        });
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === key;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }
    }
    customElements.define('product-tabs', ProductTabs);
  }

  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = html.querySelector('[data-recommendations]');
            if (recommendations && recommendations.innerHTML.trim()) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(() => {});
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
